/* eslint-disable */

import eTextInput from './eTextInput'
import eNumberInput from './eNumberInput'
import eSelect from './eSelect'
import eCheckbox from './eCheckbox'
import eDatePicker from './eDatePicker'
import eFileInput from './eFileInput'
import eButton from './eButton'
import eRadio from './eRadio'

export default {
  install (Vue) {
    Vue.component('e-text-input', eTextInput)
    Vue.component('e-number-input', eNumberInput)
    Vue.component('e-select', eSelect)
    Vue.component('e-checkbox', eCheckbox)
    Vue.component('e-datepicker', eDatePicker)
    Vue.component('e-file-input', eFileInput)
    Vue.component('e-button', eButton)
    Vue.component('e-radio', eRadio)
  }
}

export { eTextInput, eNumberInput, eSelect, eCheckbox, eDatePicker, eFileInput }



// WEBPACK FOOTER //
// ./src/plugins/formFields/index.js